import Divider from '../../../shared/divider';
import { ITopMenuDesktop, ITopMenuDesktopBeforeItem } from '../../interfaces';
import { getPersonalizationProperty } from '../../../../personalization/domain/personalization-provider';

interface ITopMenuDesktopBeforeItemProps {
    data: ITopMenuDesktop;
}

const getBeforeItemClasses = (design: string) => {
    switch(design) {
        case 'button': {
            return 'flex items-center px-4 py-1 relative no-underline bg-yellow-400 text-gray-700 rounded-3xl font-bold';
        }
        default: { // link
            return 'flex items-center py-3 mr-3 relative text-white no-underline';
        }
    }
};

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-3926
 */
const getBeforeItem = (data: ITopMenuDesktop) : ITopMenuDesktopBeforeItem[]|null => {
    const userHasSubscription = getPersonalizationProperty('hasActiveWCA') as boolean;
    return userHasSubscription ? (data.beforeOlm as ITopMenuDesktopBeforeItem[]) : (data.before as ITopMenuDesktopBeforeItem[]);
};

const TopMenuDesktopBeforeItem  = ({ data }: ITopMenuDesktopBeforeItemProps) => {

    const before = getBeforeItem(data) || [];

    return (
        <>
            {
                before.length > 0 &&
                <div className="flex items-center h-full">
                    {
                        before.map((beforeItem, m) => {

                            const linkClasses = getBeforeItemClasses(beforeItem.design);
                            const text = beforeItem.text;

                            return (
                                <a
                                    key={ `before-${ text }-${ beforeItem.link }-${ m }` }
                                    className={ linkClasses }
                                    href={ beforeItem.link }
                                    data-gaevent="Top Menu"
                                    data-gavalue={ text }>
                                    { text }
                                </a>
                            )
                        })
                    }

                    <Divider classes="top-menu-d-divider" />
                </div>
            }
        </>
    )
};

export default TopMenuDesktopBeforeItem;